import React from 'react';
import {
  Box, Select, MenuItem, Typography
} from '@mui/material';

/**
 * FilterBar
 *
 * UI component that renders the two primary schedule filters:
 * - Class Type (Striking / Grappling)
 * - Class Level (All / Beginner / Advanced / Fight Team)
 *
 * Props:
 * - filters: object containing the current filter values. Expected shape:
 *     { type: 'ST'|'GR', level: 'ALL'|'BEG'|'ADV'|'FT' }
 * - setFilters: state setter function (from parent) used to update the filters.
 *
 * Behavior / notes:
 * - This component renders values from 'filters' and calls 'setFilters' when 
 *   the user changes a Select. It does not maintain local state.
 * - handleChange(field) returns an onChange handler for a given field name. 
 *   It merges the new value into the existing filter object using a functional updater.
 */

function FilterBar({ filters, setFilters }) {
  // Returns an onChange handler that updates the specific field in the
  // filters object.
  const handleChange = (field) => (event) => {
    setFilters(prev => ({ ...prev, [field]: event.target.value }));
  };

  return (
    <Box sx={{ display: 'flex', gap: 4, mb: 4 }}>
      <Box>
        <Typography variant="subtitle2">Class Type</Typography>
        <Select value={filters.type} onChange={handleChange('type')} size="small">
          <MenuItem value="ST">Striking</MenuItem>
          <MenuItem value="GR">Grappling</MenuItem>
        </Select>
      </Box>
      <Box>
        <Typography variant="subtitle2">Class Level</Typography>
        <Select value={filters.level} onChange={handleChange('level')} size="small">
          <MenuItem value="ALL">All</MenuItem>
          <MenuItem value="BEG">Beginner</MenuItem>
          <MenuItem value="ADV">Advanced</MenuItem>
          <MenuItem value="FT">Fight Team</MenuItem>
        </Select>
      </Box>
    </Box>
  );
}

export default FilterBar;
